import React from "react";
import { WebOutlined } from "@mui/icons-material";

export const items = [
  {
    icon: <WebOutlined />,
    heading: "Web Development",
    description:
      "Modern, feature-rich, and responsive cross-platform and cross-browser interactive web apps.",
  },
  {
    icon: <WebOutlined />,
    heading: "Mobile App Development",
    description:
      "Feature-packed solutions for Android, iOS, and cross-platform mobile apps targeting any industry.",
  },
  {
    icon: <WebOutlined />,
    heading: "Custom Software Development",
    description:
      "Feature-packed solutions for Android, iOS, and cross-platform mobile apps targeting any industry.",
  },
  {
    icon: <WebOutlined />,
    heading: "Staff Augmentation",
    description:
      "Streamline your business operations without worrying about hiring the perfect talent because we do it for you.",
  },
  {
    icon: <WebOutlined />,
    heading: "QA & Testing",
    description:
      "Identifying and resolving technical issues through standard industry practices to ensure your business stays afloat.",
  },
  {
    icon: <WebOutlined />,
    heading: "Product Management",
    description:
      "Supporting and managing processes in product’s lifecycle to ensure valuable products are launched in the market.",
  },
];
